// TODO get the backend to send data properly tailored to the two charts

export interface Case {
    id: number
    closed: number
    open: number
}

export interface CaseGraphRow {
    groupedField: number
    responses: number
    closed: number
    open: number
    current: number
    overdue: number
    withinSla: number
    outsideSla: number
    timeToClose: number
    from: number
    to: number
}

export interface DataBreakdownReport {
    isSlaActive: boolean
    slaHours: number
    timeToClose: number | null
    primaryBreakdown: string
    secondaryBreakdownField: string
    secondaryBreakdownFields: string[]
    secondaryBreakdown: string
    rows: DataBreakdownRow[]
}

export interface DataBreakdownRow {
    groupedField: string
    responses: number
    closed: number
    open: number
    current: number
    overdue: number
    withinSla: number
    outsideSla: number
    timeToClose: number
}

export type CalendarUnit = 'Week' | 'Month'

export function friendlyTimeToClose(timeToClose: number, fullUnits = false) {
    const days = (Number(timeToClose) / (3600 * 24))
    if (days < 1) {
        const hoursUnit = fullUnits ? ' hours' : 'h'
        const hours = (Number(timeToClose) / (3600))
        return hours.toFixed(1) + hoursUnit
    }
    const daysUnit = fullUnits ? ' days' : 'd'
    return days.toFixed(1) + daysUnit
}
